import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './ProductLineItemPage.css';
import ProductPricingPanel from './panels/ProductPricingPanel';
import ProductLineItemHeader from './panels/ProductLineItemHeader';
import ProductInventoryPanel from './panels/ProductInventoryPanel';
import { white } from 'material-ui/styles/colors';
import typography from 'material-ui/styles/typography';
import { Button, Icon, ListSubheader } from '@material-ui/core';
import { PRODUCT_LINE_ITEM_FIELDS } from './line-item-page-util';
import PageBase from '../../../widgets/PageBase/PageBase';
import * as ValidationFields from '../../../../constants/ValidationFields';

const styles = {
  header: {
    fontSize: 24,
    fontWeight: typography.fontWeightLight,
    backgroundColor: '#3e4757',
    color: white
  }
};

class ProductLineItemPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: false
    };

    this.startLoading = this.startLoading.bind(this);
    this.stopLoading = this.stopLoading.bind(this);
    this.handleChangeLineItem = this.handleChangeLineItem.bind(this);
    this.fieldChangeRequiresApproval =
      this.fieldChangeRequiresApproval.bind(this);
  }

  fieldChangeRequiresApproval(fieldName) {
    const { lineItem } = this.props;
    switch (fieldName) {
      case PRODUCT_LINE_ITEM_FIELDS.priceRental.name:
        return (
          lineItem.isApprovalRequired &&
          lineItem.validationFields &&
          lineItem.validationFields.includes(ValidationFields.RENTAL_PRICE)
        );
      case PRODUCT_LINE_ITEM_FIELDS.priceItem.name:
        return (
          lineItem.isApprovalRequired &&
          lineItem.validationFields &&
          lineItem.validationFields.includes(ValidationFields.SALES_PRICE)
        );
      case PRODUCT_LINE_ITEM_FIELDS.priceReplace.name:
        return (
          lineItem.isApprovalRequired &&
          lineItem.validationFields &&
          lineItem.validationFields.includes(ValidationFields.REPLACE_PRICE)
        );
      case PRODUCT_LINE_ITEM_FIELDS.priceWash.name:
        return (
          lineItem.isApprovalRequired &&
          lineItem.validationFields &&
          lineItem.validationFields.includes(ValidationFields.WASH_PRICE)
        );
      case PRODUCT_LINE_ITEM_FIELDS.minUsePercentage.name:
        return (
          lineItem.isApprovalRequired &&
          lineItem.validationFields &&
          lineItem.validationFields.includes(
            ValidationFields.MIN_USE_PERCENTAGE
          )
        );
      case PRODUCT_LINE_ITEM_FIELDS.rentalQuantity.name:
        return (
          lineItem.isApprovalRequired &&
          lineItem.validationFields &&
          lineItem.validationFields.includes(ValidationFields.RENTAL_QUANTITY)
        );
      case PRODUCT_LINE_ITEM_FIELDS.deliveryQuantity.name:
        return (
          lineItem.isApprovalRequired &&
          lineItem.validationFields &&
          lineItem.validationFields.includes(ValidationFields.DELIVERY_QUANTITY)
        );
      case PRODUCT_LINE_ITEM_FIELDS.inventoryMaintenance.name:
        return (
          lineItem.isApprovalRequired &&
          lineItem.validationFields &&
          lineItem.validationFields.includes(
            ValidationFields.INVENTORY_MAINTENANCE
          )
        );
      case PRODUCT_LINE_ITEM_FIELDS.circulatingInventory.name:
        return (
          lineItem.isApprovalRequired &&
          lineItem.validationFields &&
          lineItem.validationFields.includes(
            ValidationFields.CIRCULATING_INVENTORY
          )
        );
      case PRODUCT_LINE_ITEM_FIELDS.weeklyUsage.name:
        return (
          lineItem.isApprovalRequired &&
          lineItem.validationFields &&
          lineItem.validationFields.includes(ValidationFields.WEEKLY_USAGE)
        );
      default:
        return false;
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      loading: false
    };
  }

  startLoading() {
    this.setState({
      loading: true
    });
  }

  stopLoading() {
    this.setState({
      loading: false
    });
  }

  handleChangeLineItem(updatedLineItem, submitUpdates) {
    this.startLoading();
    this.props.handleChangeLineItem(updatedLineItem, submitUpdates);
  }

  render() {
    return (
      <PageBase
        navigation={[
          this.props.customer.billToCustomerName.toLowerCase(),
          'Renewal',
          'Product'
        ]}
        noWrapContent
        loading={this.state.loading}
      >
        <div className="row">
          <div className="col-xs-12 col-md-4 col-lg-3">
            <div className="btn-action btn-back">
              <Button onClick={this.props.handleBackButton}>
                <Icon>navigate_before</Icon>
                Renewal Product list
              </Button>
            </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 title-bar-wrapper">
            <ListSubheader style={styles.header}>Product Details</ListSubheader>
          </div>
        </div>
        <form>
          <ProductLineItemHeader
            location={this.props.location}
            lineItem={this.props.lineItem}
            handleChangeLineItem={this.handleChangeLineItem}
            isFieldEditable={this.props.isFieldEditable}
            deliveryFrequencies={this.props.deliveryFrequencies}
            disabled={this.props.disabled}
          />
          <ProductPricingPanel
            lineItem={this.props.lineItem}
            handleChangeLineItem={this.handleChangeLineItem}
            isFieldEditable={this.props.isFieldEditable}
            fieldChangeRequiresApproval={this.fieldChangeRequiresApproval}
            priceReasonCodes={this.props.priceReasonCodes}
            disabled={this.props.disabled}
          />
          <ProductInventoryPanel
            lineItem={this.props.lineItem}
            handleChangeLineItem={this.handleChangeLineItem}
            isFieldEditable={this.props.isFieldEditable}
            fieldChangeRequiresApproval={this.fieldChangeRequiresApproval}
            disabled={this.props.disabled}
          />
        </form>
      </PageBase>
    );
  }
}

ProductLineItemPage.propTypes = {
  lineItem: PropTypes.object,
  handleChangeLineItem: PropTypes.func,
  handleBackButton: PropTypes.func,
  isFieldEditable: PropTypes.func,
  customer: PropTypes.object,
  deliveryFrequencies: PropTypes.array,
  priceReasonCodes: PropTypes.array,
  disabled: PropTypes.bool
};

export default ProductLineItemPage;
